import { AppButton as CommonAppButton } from '@common-fe/common-fe';
import styled from 'styled-components';

const AppButton = styled(CommonAppButton)`

`;

export default AppButton;
